// extracted by mini-css-extract-plugin
module.exports = {"image":"ResponsiveImage_image__VqR_q","card":"ResponsiveImage_card__ipR18","single":"ResponsiveImage_single__qvVN2","fmg":"ResponsiveImage_fmg__4oDqh"};